import NotificationBell from './NotificationBell';

export default NotificationBell;
